import { motion, AnimatePresence } from 'framer-motion';
import { X, Plus, Minus, Trash2, ShoppingBag } from 'lucide-react';
import { useCart } from '../lib/CartContext';
import { createCartCheckout } from '../lib/api';
import { useState } from 'react';

export default function CartDrawer() {
  const { items, isOpen, setIsOpen, updateQuantity, removeItem, totalItems, totalPrice, clearCart } = useCart();
  const [loading, setLoading] = useState(false);

  const handleCheckout = async () => {
    if (items.length === 0) return;
    setLoading(true);
    try {
      const cartItems = items.map(i => ({ lookup_key: i.lookup_key, quantity: i.quantity }));
      const res = await createCartCheckout(cartItems, window.location.origin);
      if (res.data?.checkout_url) {
        window.location.href = res.data.checkout_url;
      }
    } catch (err) {
      alert('Checkout failed. Please try again.');
      setLoading(false);
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            className="cart-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsOpen(false)}
          />
          <motion.div
            className="cart-drawer"
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
            data-testid="cart-drawer"
          >
            <div className="cart-header">
              <h3 className="cart-title">
                <ShoppingBag size={18} /> Your Cart ({totalItems})
              </h3>
              <button className="cart-close" onClick={() => setIsOpen(false)} data-testid="cart-close">
                <X size={20} />
              </button>
            </div>

            {items.length === 0 ? (
              <div className="cart-empty">
                <ShoppingBag size={40} strokeWidth={0.8} />
                <p>Your cart is empty</p>
              </div>
            ) : (
              <>
                <div className="cart-items">
                  {items.map(item => (
                    <div key={item.lookup_key} className="cart-item" data-testid={`cart-item-${item.lookup_key}`}>
                      {item.image && <img src={item.image} alt={item.name} className="cart-item-img" />}
                      <div className="cart-item-info">
                        <p className="cart-item-name">{item.name}</p>
                        <p className="cart-item-price">${item.price.toFixed(2)}</p>
                      </div>
                      <div className="cart-item-qty">
                        <button onClick={() => updateQuantity(item.lookup_key, item.quantity - 1)} data-testid={`qty-minus-${item.lookup_key}`}>
                          <Minus size={14} />
                        </button>
                        <span>{item.quantity}</span>
                        <button onClick={() => updateQuantity(item.lookup_key, item.quantity + 1)} data-testid={`qty-plus-${item.lookup_key}`}>
                          <Plus size={14} />
                        </button>
                      </div>
                      <button className="cart-item-remove" onClick={() => removeItem(item.lookup_key)} data-testid={`remove-${item.lookup_key}`}>
                        <Trash2 size={14} />
                      </button>
                    </div>
                  ))}
                </div>
                <div className="cart-footer">
                  <div className="cart-total">
                    <span>Subtotal</span>
                    <span className="cart-total-price">${totalPrice.toFixed(2)}</span>
                  </div>
                  <p className="cart-tax-note">Taxes calculated at checkout</p>
                  <button className="cart-checkout-btn" onClick={handleCheckout} disabled={loading} data-testid="cart-checkout-btn">
                    {loading ? 'Redirecting...' : 'CHECKOUT'}
                  </button>
                </div>
              </>
            )}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
